import React, { useState } from "react";
import { useRole } from "../contextApi/RoleContext";
import Cookies from "js-cookie";

const ProfileImg = ({ setProfileImage, profileImage }) => {
  const [uploadStatus, setUploadStatus] = useState("");
  const API_URL = process.env.REACT_APP_BASE_URL;
  const {
    setRole,
    role,
    setPermission,
    permission,
    setUserDetails,
    userDetails,
  } = useRole();

  const handleImageChange = async (event) => {
    const file = event.target.files[0];
    if (file) {
      //send image to backend
      // alert("test");
      const formData = new FormData();
      formData.append("image", file);
      formData.append("id", Cookies.get("loginid"));
      try {
        const response = await fetch(`${API_URL}ImageUpload.php`, {
          method: "POST",
          body: formData,
        });

        const result = await response.json();
        if (response.ok) {
          setUploadStatus(result.message);
        } else {
          setUploadStatus(`Error: ${result.message}`);
        }
      } catch (error) {
        setUploadStatus("Error uploading file");
      }
      //////////////

      const reader = new FileReader();
      reader.onload = (e) => {
        // console.log(e.target.result);
        setProfileImage(e.target.result); // Update the profile image
      };
      reader.readAsDataURL(file);
    }
  };

  return (
    <div className="profile-container">
      <div className="profile-image-container">
        <img src={profileImage} alt="Profile" className="profile-image" />
        <div className="profile-overlay">
          <label htmlFor="profile-upload-input" className="camera-icon">
            <i class="mdi mdi-camera"></i>
          </label>
          <input
            type="file"
            id="profile-upload-input"
            accept="image/*"
            onChange={handleImageChange}
          />
        </div>
      </div>
    </div>
  );
};

export default ProfileImg;
